<template>
	<v-card align="center" justify="center" class="mx-auto mt-12 elevation-8" style="max-width: 500px">
		<v-card-title class="text-center headline font-weight-black">
			<v-spacer></v-spacer>
			Account Disabled
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-subtitle class="text-center red--text"> Your account has been disabled, please contact <a>hello@locumbase.com</a> to activate your account </v-card-subtitle>
	</v-card>
</template>

<script>
export default {
	name: 'UserUnapprovedPage',
};
</script>
